import React from "react";

const SummaryCard = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="p-5 rounded-md shadow-md bg-white text-center">
        <h3 className="text-xl mb-4 font-medium uppercase">Jumlah Unit Rampasan</h3>
        <p>No data available</p>
      </div>
    );
  }

  // Calculate total arrears
  const totalArrears = data.reduce((sum, item) => sum + (item.arrears || 0), 0);

  // Get unique unit numbers
  const uniqueUnits = [...new Set(data.map((item) => item.unitNumber))];
  const totalUnits = uniqueUnits.length;

  // Find the latest updatedAt date
  const latestUpdate = new Date(
    Math.max(...data.map((item) => new Date(item.updatedAt)))
  );

  return (
    <div className="p-5 rounded-md shadow-md bg-white">
      <h3 className="text-xl mb-4 font-medium uppercase">Jumlah Unit Rampasan</h3>

      <div className="mb-3">
        <h3 className="text-lg">
          Jumlah Tunggakan :
          <span className="text-xl font-medium">
            {" "}
            RM {totalArrears.toLocaleString()}
          </span>
        </h3>
      </div>

      <div className="mb-3">
        <h3 className="text-lg">
          Jumlah Unit :
          <span className="text-xl font-medium"> {totalUnits} Unit</span>
        </h3>
      </div>

      <div className="flex justify-end items-baseline">
        <p>Dikemaskini pada :</p>
        <p className="ms-1">{latestUpdate.toLocaleDateString("en-GB")}</p>
      </div>
    </div>
  );
};

export default SummaryCard;
